import styled from '@emotion/styled';

import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { color } from 'src/shared/styles/variables';
import { fontNames } from './fonts';

const fontsWeightMap = new Map([
    [fontNames.black, 900],
    [fontNames.heavy, 700],
    [fontNames.medium, 500],
    [fontNames.book, 400],
    [fontNames.light, 300],
    [fontNames.roman, 300],
]);

type FontStyle = {
    fontSize: number;
    fontFamily: string;
    fontWeight: number;
};

export const font = (name: string, fontWeight?: number): ((size: number) => FontStyle) => (
    size: number = 14,
) => {
    const styles = {
        fontSize: size,
        fontFamily: `${name}, Helvetica, sans-serif`,
    };

    if (fontWeight) {
        return { ...styles, fontWeight };
    }

    return {
        ...styles,
        fontWeight: fontsWeightMap.get(name) || 500,
    };
};

interface TriangleProps {
    right: number;
    size: number;
    bottom?: number;
    darker?: boolean;
}

export const Triangle = styled('div')<TriangleProps>(
    ({ right = 0, bottom = 0, size = 150, darker = false }) => ({
        position: 'absolute',
        right,
        bottom,
        width: 0,
        height: 0,
        borderLeft: `${size * 0.7}px solid transparent`,
        borderRight: `${size * 0.7}px solid transparent`,
        borderBottom: `${size}px solid rgba(255, 255, 255, 0.${darker ? 2 : 1})`,
    }),
);

type BoxShadowType = 'heavy' | 'normal' | 'mild';

export const boxShadow = (type: BoxShadowType) => {
    switch (type) {
        case 'heavy':
            return { boxShadow: `0 1px 10px 0 ${hexToRgba(color.silverChalice, 0.5)}` };
        case 'normal':
            return { boxShadow: `0 0 4px 0 ${hexToRgba(color.black, 0.1)}` };
        case 'mild':
            return { boxShadow: `0 1px 2px 0 ${hexToRgba(color.silverChalice, 0.5)}` };
        default:
            return '';
    }
};
